const baseUrl = process.env.REACT_APP_API_URL || 'https://api.dev.bakerstuart.wesoftyou.club';
export const URL = `${baseUrl}/admin/people_look_reports/reportgraph/:graphId/change/`;
export const SERIES_URL = `${baseUrl}/admin/people_look_reports/reportgraphseries/:seriesId/change/`;
export const MODIFIER_URL = `${baseUrl}/admin/people_look_reports/reportgraphmodifiers/:modifierId/change/`;
export const TEMPLATE_URL = `${baseUrl}/admin/people_look_templates/template/:templateID/change/`;
